import type { PdfItem } from '../types/pdf';
import { apiUrl } from './api';

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(apiUrl(path), { ...init, credentials: 'include' });
  if (!response.ok) throw new Error((await response.json().catch(() => null))?.error ?? `Request failed (${response.status})`);
  return response.status === 204 ? undefined as T : response.json();
}
export const pdfService = {
  list: async () => (await request<PdfItem[]>('/api/pdfs')).map((item) => ({ ...item, url: apiUrl(item.url), thumbnail: item.thumbnail ? apiUrl(item.thumbnail) : undefined })),
  syncAll: () => request<{ started: number }>('/api/sync', { method: 'POST' }),
};
export { request };
